export var Redirect;
(function (Redirect) {
    function go(location, params, res) {
        return GET(location, params, res);
    }
    Redirect.go = go;
    function DOWNLOAD(url, fileName) {
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || url.split('/')[0]);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }
    Redirect.DOWNLOAD = DOWNLOAD;
    function GET(location, params, res) {
        var loca = location + (params ? '?' + new URLSearchParams(params).toString() : '');
        if (res) {
            res.setHeader("location", loca);
            res.statusCode = 302;
            res.end();
        }
        else {
            window.location.href = loca;
        }
        return;
    }
    Redirect.GET = GET;
    function POST(location, body) {
        document.children[0].innerHTML = "<form id=\"redirect-post-form\" name=\"redirect-post-form\" action=\"".concat(location, "\" method=\"POST\" style=\"display:none;\"></form>");
        if (body) {
            body = Object.assign({}, body);
            addDataToForm('redirect-post-form', body);
        }
        document.forms['redirect-post-form'].submit();
        return;
    }
    Redirect.POST = POST;
    function addDataToForm(form, data) {
        if (typeof form === 'string') {
            if (form[0] === '#')
                form = form.slice(1);
            form = document.getElementById(form);
        }
        if (!form)
            return;
        var keys = Object.keys(data);
        var name;
        var value;
        var input;
        for (var i = 0; i < keys.length; i++) {
            name = keys[i];
            if (typeof data[name] === 'object')
                value = JSON.stringify(data[name]);
            else
                value = data[name];
            input = document.createElement('input');
            input.setAttribute('name', name);
            input.setAttribute('value', value);
            input.setAttribute('type', 'hidden');
            form.appendChild(input);
        }
        return form;
    }
})(Redirect || (Redirect = {}));
